// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'sport1Regular', Sport1-Regular-Fallback"},"className":"__className_2d50c9","variable":"__variable_2d50c9"};